export default class TaskSettings {
  constructor(settings) {
    this.is_moderated = settings.is_moderated || false;
    this.is_online = settings.is_online || false;
    this.is_appeal = settings.is_appeal || false;
    this.passing_score = settings.passing_score || false;
    this.minutes_to_solve = settings.minutes_to_solve || 0;
    this.issuance_tags = settings.issuance_tags || []; // { name, count }[]
  }
}
